import React, { useState } from "react";
import "../css/competencias.css";

const Asignatura = ({ asignatura }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="asignatura-item">
   
      <button className="asignatura-trigger" onClick={() => setIsOpen(!isOpen)}>
        <span> {asignatura.nombre}</span>
        <span className={`icon-arrow ${isOpen ? "open" : ""}`}>▼</span>
      </button>

      {isOpen && (
        <div className="evidencias-content">
          {asignatura.evidencias.map((ev, index) => (
            <div key={index} className="evidencia-block">
              <span className="tipo-evidencia">  <p><b> Evidencias requeridas:</b> {ev.tipo}</p></span>
              <ul className="evidencias-list">
                   
                {ev.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const CompetenciaComponent = ({ datos }) => {
  return (
    <div className="competencias-wrapper">
      {datos.map((comp) => (
        <div key={comp.id} className="competencia-container">
          <div className="competencia-header">
            <span className="competencia-label">Competencia Académica</span>
            <h2>{comp.titulo}</h2>
          </div>

          <div className="asignaturas-list">
             <p>Asignaturas:</p>
            {comp.asignaturas.map((asig, index) => (
              <>   
              <Asignatura key={index} asignatura={asig} /></>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompetenciaComponent;
